import React from "react";

function SaleDashBoard() {
  return <div>SaleDashBoard</div>;
}

export default SaleDashBoard;
